import logger from "logging/logger";
import { ICompanyServicePlan } from "modules/company/types";

export const hasGuestPrice = (plan: ICompanyServicePlan | null): boolean => {
  if (Number.isFinite(plan?.guestPrice) === true) {
    logger.info(`Overriding guest days for: ${plan}`);
  }
  return false;
};
